import type { ToastMessageOptions } from "primevue/toast";
import type { ToastServiceMethods } from "primevue/toastservice";

import { Ref } from "vue";

import { createContext, useContext } from "@/hooks/contexts.ts";

export type AdditionalToastServiceMethods = ToastServiceMethods & {
  success: (msg: unknown, opts?: ToastMessageOptions) => void;
  info: (msg: unknown, opts?: ToastMessageOptions) => void;
  warn: (msg: unknown, opts?: ToastMessageOptions) => void;
  error: (msg: unknown, opts?: ToastMessageOptions) => void;
};

export const ToastContext = createContext<AdditionalToastServiceMethods>({
  add: () => {},
  remove: () => {},
  removeAllGroups: () => {},
  removeGroup: () => {},
  success: () => {},
  info: () => {},
  warn: () => {},
  error: () => {},
});

export function useVoltacallToast(): Ref<AdditionalToastServiceMethods> {
  return useContext(ToastContext);
}
